import { FC } from "react";
import { Script, ScriptStrategy } from "gatsby";
import { GOOGLE_CONSENT_UPDATE_JS } from "./gtmScripts";

interface ThirdPartyScriptsProps {
  children: React.ReactNode;
  isDev: boolean;
}

const ONETRUST_DOMAIN_SCRIPT = "84abbc5d-a278-4b63-ab38-e742e0aee49d";

const ThirdPartyScripts: FC<ThirdPartyScriptsProps> = ({ children, isDev }) => {
  if (isDev) {
    return <>{children}</>;
  }
  return (
    <>
      <Script
        id="hh-third-party-loader"
        strategy={ScriptStrategy.idle}
        dangerouslySetInnerHTML={{
          __html: `
(function(w,d){${GOOGLE_CONSENT_UPDATE_JS}
  function pushLoadAfterIdle(){
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({'event':'load-after-idle', 'platform':'aws'});
  }
  function loadOptanon(){
    var s = d.createElement('script');
    s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    s.async = true;
    s.type = 'text/javascript';
    s.charset = 'UTF-8';
    s.setAttribute('data-document-language', 'true');
    s.setAttribute('data-domain-script', '${ONETRUST_DOMAIN_SCRIPT}');
    d.head.appendChild(s);
  }
  w.OptanonWrapper = function(){
    updateGoogleConsent();
    if (w.__hh_trackOneTrustGroupsUpdated) {
      try {
        var ag = typeof w.OnetrustActiveGroups !== 'undefined' ? w.OnetrustActiveGroups : '';
        w.__hh_trackOneTrustGroupsUpdated(ag);
      } catch (e) {}
    }
  };
  pushLoadAfterIdle();
  loadOptanon();
})(window, document);
`,
        }}
      />
      {children}
    </>
  );
};

export default ThirdPartyScripts;
